import React, { useContext } from "react";
import styled from "styled-components";
import { SegmentedPicker, SectionRibbon, colors } from "../../../../../ui";
import { UserContext } from "../../../_context/UserContext";

export const AlertNavFC = ({ adminViewToggle, setAdminViewToggle }) => {
  const { user, userRoles } = useContext(UserContext);

  // Define navigation options based on user roles
  const getNavigationOptions = () => {
    if (userRoles.includes("superuser") || userRoles.includes("alerter")) {
      return [
        { eventKey: "User", label: "User Alerts" },
        { eventKey: "Default", label: "Manage Default Alerts" },
        { eventKey: "All", label: "All User Alerts" },
        { eventKey: "Templates", label: "Alert Templates" },
      ];
    } else if (userRoles.includes("admin")) {
      return [
        { eventKey: "User", label: "User Alerts" },
        { eventKey: "All", label: "All User Alerts" },
      ];
    }
    return [];
  };

  const navigationOptions = getNavigationOptions();

  if (navigationOptions.length === 0) {
    return null;
  }

  return (
    <AlertNavContainer>
      <NavigationSection>
        <SegmentedPicker
          options={navigationOptions}
          activeKey={adminViewToggle}
          onSelect={setAdminViewToggle}
          variant="glass"
          size="medium"
        />
      </NavigationSection>
    </AlertNavContainer>
  );
};

// Modern Styled Components with Glass Morphism
const AlertNavContainer = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const NavigationSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 16px;

  @media screen and (max-width: 768px) {
    padding: 0 8px;
  }
`;
